import tool from "./tool"

let live = {
    origin: "http://img.fjkankan.com",
    //将聊天信息框的滚动条拉到底部
    toBottom: () => {
        let chat = tool.getByID("zhibochat");
        chat.appendChild(document.createElement("br"));
        chat.scrollTo(0, document.documentElement.clientHeight);
    },
    //拼接等级图片
    makeLevelImg:(res)=>{
        let level = 0;//用户等级标识
        let cStr = res.chatuserinfo.split("-");
        if (cStr.length > 5) {
            level = cStr[2];
            if (level.indexOf("_") == -1) {
                level += "_0";
            }
        }else{
            level = "0";
        }    
        return "http://img.fjkankan.com/img/lvv2/lvlv/" + level +".png";
    },
    //进场
    into: (res, id) => {
        let p = document.createElement("p");
        p.classList.add("jinchang");
        p.classList.add("radius03rem");
        if (res.nickname.indexOf("Guest") != -1) {
            res.nickname = res.nickname.subString(0,10);
            res.nickname = res.nickname.replace("Guest","游客");
        }
        //用户等级
        let img = live.makeLevelImg(res);
        p.innerHTML = "<img class='level' src='" + img +"'>&nbsp;<span>欢迎</span> <span class='giftName'>" + res.nickname + "</span> <span>进入房间</span>";
        let f = tool.getByID(id);
        f.appendChild(p);

        live.toBottom(id);
    },
    //公共聊天
    say: (res, id) => {
        let name = "";
        if (res.chatuserinfo != "") {
            name = res.chatuserinfo.split("-")[1];
        }

        let p = document.createElement("p");
        p.classList.add("chats");
        p.classList.add("putong");
        p.classList.add("radius03rem");
        //用户等级
        let img = live.makeLevelImg(res);
        p.innerHTML = "<img class='level' src='" + img +"'>&nbsp;<span>" + name + "</span>&nbsp;:&nbsp;" + "<span>"+ res.msg +"</span>";
        let f = tool.getByID(id);
        f.appendChild(p);

        live.toBottom(id);
    },
    //私人聊天
    sayPerson: (res, id) => {
        let name = "";
        if (res.chatuserinfo != "") {
            name = res.chatuserinfo.split("-")[1];
        }

        let p = document.createElement("p");
        p.classList.add("chats");
        p.classList.add("putong");
        p.classList.add("radius03rem");
        p.innerHTML = "<span>" + name + "@你</span>:" + res.msg;
        let f = tool.getByID(id);
        f.appendChild(p);

        live.toBottom(id);
    },
    //接受送礼物信息
    getGift: (res, id) => {
        let f = tool.getByID(id);
        let get = ""; //接受礼物的人
        let send = ""; //送礼物的人
        let gifts = null;
        if (res.r.indexOf("SFM0") != -1) {
            //有动效
        } else {
            //无动效
            gifts = res.r.split("|");
            send = res.chatuserinfo.split("-")[1];
            get = gifts[4].replace(",", "");
        }
        //用户等级
        let img = live.makeLevelImg(res);
        let p = document.createElement("p");
        p.classList.add("chats");
        p.classList.add("putong");
        p.classList.add("radius03rem");

        if (res.r.indexOf("SFM0") != -1) {
            //有动效的礼物
        } else {
            //无动效的礼物
            p.innerHTML = "<img class='level' src='" + img +"'>&nbsp;<span class='giftName'>" + send + "</span><span>送了</span>" + "<span class='giftName'>" + get + "</span><span>1个</span><span class='giftItem'>" + gifts[gifts.length - 1] + "</span>";

            f.appendChild(p);
            live.toBottom(id);
        }

    },
    //接受公告信息
    getGonggao: (res, id) => {
        let gonggao = res.r.split("|")[1];
        let p = document.createElement("p");
        p.classList.add("chats");
        p.classList.add("putong");
        p.classList.add("radius03rem");
        p.innerHTML = gonggao;
        let f = tool.getByID(id);
        f.appendChild(p);

        live.toBottom(id);
    }
}

// if (window.location.host == 'test.h5.fjkankan.com') {
//     live.origin = "http://test.wapapi.fjkankan.com";
// } else {
//     live.origin = "https://wap.fjkankan.com";
// }

export default live;